import { Route } from '@angular/router';

import { matchOnlineGameRoutes } from '../../online-games/games/match/online-games-match.routes';

export const matchGameRoutes: Route[] = [...matchOnlineGameRoutes];
